module.exports = __webpack_public_path__ + "static/media/phone-bubble-glyph.ffd8c959.svg";